import React from 'react'
import styles from './context-menu.styles'
import injectSheet from 'react-jss'
import MoreButton from 'pobble-components/dist/more-button'
import DropMenu from 'pobble-components/dist/drop-menu'
import PencilIcon from 'react-icons/lib/fa/pencil'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'
import CloseIcon from 'react-icons/lib/fa/lock'
import StarIcon from 'react-icons/lib/fa/star'
import TrainingIcon from 'react-icons/lib/fa/graduation-cap'
import PlusIcon from 'react-icons/lib/fa/plus'
import MinusIcon from 'react-icons/lib/fa/minus'
import { SubsCrown } from 'pobble-components/dist/subscriptions'

const ContextMenu = ({
  classes,
  id,
  title,
  description,
  example,
  trainingMaterial,
  benchmarked,
  canUpdate,
  isClosed,
  canClose,
  onClose,
  onReopen,
  onOpenEditTitleDialog,
  canMarkAsExample,
  canMarkAsTrainingMaterial,
  onMarkAsExample,
  onUnmarkAsExample,
  onMarkAsTrainingMaterial,
  onUnmarkAsTrainingMaterial,
  canMarkAsBenchmark,
  onMarkAsBenchmark,
  onUnmarkAsBenchmark,
  canManageAFs,
  onCopy,
  canSeeContextMenu,
  moderation_type,
  judgement,
  canMarkAsPremium,
  premium,
  onMarkAsPremium,
  onUnmarkAsPremium
}) =>
  canSeeContextMenu && (
    <DropMenu
      button={({ ref, togglePopover }) => (
        <MoreButton
          forwardedRef={ref}
          onClick={togglePopover}
          className={classes.moreButton}
        />
      )}>
      {({ Menu, MenuItem, IconHolder, Separator, closePopover }) => (
        <Menu>
          {canUpdate && (
            <MenuItem
              onClick={() => {
                onOpenEditTitleDialog(
                  id,
                  title,
                  description,
                  moderation_type,
                  judgement
                )
                closePopover()
              }}>
              <IconHolder>
                <PencilIcon />
              </IconHolder>
              <div>
                <div>Edit</div>
                <small>File name, description, type and judgement</small>
              </div>
            </MenuItem>
          )}
          {/*canManageAFs && (
          <MenuItem
            onClick={() => {
              onCopy(id)
              closePopover()
            }}>
            <IconHolder>
              <CopyIcon />
            </IconHolder>
            Copy
          </MenuItem>
        )*/}
          {canClose && !isClosed && (
            <MenuItem
              onClick={() => {
                openConfirmationDialog({
                  bodyText:
                    'Closing this moderation file will stop contributions. Are you sure you want to close this moderation file?',
                  action: () => onClose(id),
                  confirmText: 'Close',
                  cancelText: 'Cancel'
                })
                closePopover()
              }}>
              <IconHolder>
                <CloseIcon />
              </IconHolder>
              Close
            </MenuItem>
          )}
          {canClose && isClosed && (
            <MenuItem
              onClick={() => {
                onReopen(id)
                closePopover()
              }}>
              <IconHolder>
                <CloseIcon />
              </IconHolder>
              Reopen
            </MenuItem>
          )}
          {canMarkAsExample && !example && (
            <MenuItem
              onClick={() => {
                openConfirmationDialog({
                  bodyText:
                    'We highly recommend getting permission from the school leadership team before selecting a file to be used as a writing sample on Pobble',
                  action: () => onMarkAsExample(id),
                  confirmText: 'Mark as exemplification',
                  cancelText: 'Cancel'
                })
                closePopover()
              }}>
              <IconHolder>
                <StarIcon />
              </IconHolder>
              Add to the writing samples
            </MenuItem>
          )}
          {canMarkAsExample && example && (
            <MenuItem
              onClick={() => {
                onUnmarkAsExample(id)
                closePopover()
              }}>
              <IconHolder>
                <StarIcon />
              </IconHolder>
              Remove as a writing samples
            </MenuItem>
          )}
          {canMarkAsTrainingMaterial && !trainingMaterial && (
            <MenuItem
              onClick={() => {
                onMarkAsTrainingMaterial(id)
                closePopover()
              }}>
              <IconHolder>
                <TrainingIcon />
              </IconHolder>
              Mark as training material
            </MenuItem>
          )}
          {canMarkAsTrainingMaterial && trainingMaterial && (
            <MenuItem
              onClick={() => {
                onUnmarkAsTrainingMaterial(id)
                closePopover()
              }}>
              <IconHolder>
                <TrainingIcon />
              </IconHolder>
              Unmark as training material
            </MenuItem>
          )}
          {canMarkAsBenchmark && !benchmarked && (
            <MenuItem
              onClick={() => {
                onMarkAsBenchmark(id)
                closePopover()
              }}>
              <IconHolder>
                <PlusIcon />
              </IconHolder>
              Add as an exemplar to my school files
            </MenuItem>
          )}
          {canMarkAsBenchmark && benchmarked && (
            <MenuItem
              onClick={() => {
                onUnmarkAsBenchmark(id)
                closePopover()
              }}>
              <IconHolder>
                <MinusIcon />
              </IconHolder>
              Remove as a school exemplar
            </MenuItem>
          )}
          {canMarkAsPremium && !premium && (
            <MenuItem
              onClick={() => {
                onMarkAsPremium(id)
                closePopover()
              }}>
              <IconHolder>
                <SubsCrown />
              </IconHolder>
              Mark this file as premium
            </MenuItem>
          )}
          {canMarkAsPremium && premium && (
            <MenuItem
              onClick={() => {
                onUnmarkAsPremium(id)
                closePopover()
              }}>
              <IconHolder>
                <SubsCrown />
              </IconHolder>
              Unmark this file as premium
            </MenuItem>
          )}
        </Menu>
      )}
    </DropMenu>
  )

export default injectSheet(styles)(ContextMenu)
